import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Empty, Spin, Table, message } from 'antd'
import { renderCountOrGrayZero, renderTextStr } from '@/utils/renderUtils'
import { fetchTuinaMemberEntitlements } from '@/redux/tuina/memberEntitlementsSlice'

const columns = [
  {
    title: '套餐',
    dataIndex: 'projectName',
    render: (v) => renderTextStr(v)
  },
  {
    title: '时长',
    dataIndex: 'durationMinutes',
    width: 88,
    render: (v) => {
      const n = Number(v)
      if (v == null || v === '' || !Number.isFinite(n)) return renderTextStr(v)
      return `${n}分钟`
    }
  },
  {
    title: '剩余次数',
    dataIndex: 'availableCount',
    width: 96,
    align: 'right',
    render: (v) => renderCountOrGrayZero(v)
  }
]

class MemberEntitlementDetail extends React.Component {
  static propTypes = {
    record: PropTypes.object,
    memberEntitlements: PropTypes.object,
    dispatch: PropTypes.func
  }

  componentDidMount () {
    const { record, dispatch } = this.props
    if (record == null || record.id == null || record.id === '') return
    dispatch(fetchTuinaMemberEntitlements({ query: { id: record.id } }))
      .unwrap()
      .catch((err) => message.error(typeof err === 'string' ? err : '加载套餐失败'))
  }

  render () {
    const { record, memberEntitlements } = this.props
    const memberId = record && record.id
    const match = memberEntitlements
      && String(memberEntitlements.query.id) === String(memberId)
    const rows = match && Array.isArray(memberEntitlements.data)
      ? memberEntitlements.data
      : []

    return (
      <Spin spinning={Boolean(memberEntitlements && memberEntitlements.fetching)}>
        {rows.length === 0 && !(memberEntitlements && memberEntitlements.fetching)
          ? <Empty description="暂无套餐" />
          : (
            <Table
              rowKey={(row, index) => `${row.projectId || row.projectName || 'pkg'}-${index}`}
              columns={columns}
              dataSource={rows}
              pagination={false}
              size="middle"
            />
          )}
      </Spin>
    )
  }
}

const mapStateToProps = (state) => ({
  memberEntitlements: state.tuina.memberEntitlements
})

export default connect(mapStateToProps)(MemberEntitlementDetail)
